import React from "react";
import { useCallback, useState } from "react";

import { EditIcon } from "icons";

import IconButton from "components/IconButton";

import LocationEditDialog from "entities/Deal/components/OverviewLocation/LocationEditDialog";

export interface ILocationEditButton {}

const LocationEditButton: React.FC<ILocationEditButton> = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <IconButton
        onClick={handleOpen}
        data-testid="edit-location-section-button"
      >
        <EditIcon />
      </IconButton>
      <LocationEditDialog open={open} handleClose={handleClose} />
    </>
  );
};

export default LocationEditButton;
